import { ModelElement, ModelWriter } from 'ckeditor5';

export const autoParagraphEmptyContent = (writer: ModelWriter) => {
  const { document } = writer.model;
  const root = document.getRoot('main');
  let hasChangedContent = false;

  if (root) {
    // check if there are two section headings without any content in between
    for (const child of root.getChildren()) {
      const element = child as ModelElement;
      if (
        element.name === 'sectionHeading' &&
        ((element.nextSibling && (element.nextSibling as ModelElement).name === 'sectionHeading') ||
          !element.nextSibling)
      ) {
        writer.insert(writer.createElement('paragraph'), element, 'after');
        hasChangedContent = true;
      }
    }
  }

  return hasChangedContent;
};
